<template>
	<div class="" id="" style="">
		<header-vue></header-vue>
		<div class="container-l2">
			<div class="detail-content">
				<!--公司选择-->	
				<div class="clear text-right">
					<choose-company @event1="changeCom($event)" :areaFlag="areaFlag"></choose-company>
				</div>
				<div class="znjg-box" v-if="airInfo.length>0" v-for="(item,index) in airInfo" :key="index">
					<div class="znjg-boxs position-relative">
						<h3 v-text="item.name"></h3>
						<div class="control">
							<span @click="toControl(item)">
								<i class="fa fa-snowflake-o"></i>
								远程控制
							</span>
						</div>
						
					</div>
					<div class="znjg-boxs" v-if="item.communityState">
						<p class="p4" v-if="item.communityState">
						<i class="fa fa-dot-circle-o"></i>
						{{item.communityState.name}}
						<span class="num"
								:class="{'status danger':item.communityState.isHealthy=='N',status:item.communityState.value=='正常'}"
								v-text="item.communityState.value"></span>
						</p>
					</div>
					<div class="znjg-boxs" v-if="item.dataList">
						<p class="p4" v-if="value.name" v-for="(value,key,index) in item.dataList" :key="index">
						<i class="fa fa-dot-circle-o"></i>
						{{value.name}}
						<em>{{value.unit}}</em>
						<span class="num"
								:class="{'status danger':value.isHealthy=='N',status:value.value=='正常'}"
								v-text="value.value"></span>
						</p>
					</div>
				</div>
				<div v-if="airInfo.length<=0">
					<p class="text-center dangerp mt120">无法获取数据或无相关设备！</p>
				</div>

			</div>

		</div>

		<el-dialog title="远程控制" :visible.sync="conFlag" width="500px" >
			<!-- 控制组件 -->
		    <control-device ref="mychild" :tts_device_id="tts_device_id" :deviceData="deviceData"></control-device>

			<div slot="footer" class="dialog-footer">
				<el-button @click="conFlag=false">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import chooseCompany from './../comss/chooseCompany.vue'
	// 远程控制
	import controlDevice from './../comss/controlDevice.vue'
	export default {
		components: {
		    chooseCompany,controlDevice
		   },
		mounted() {
			this.$nextTick(function() {
				this.getAirList();

			})
			const timer = setInterval(() => {
				this.getAirList();
			}, 5000);

			this.$once('hook:beforeDestroy', () => {
				clearInterval(timer);
			})

		},
		
		data() {
			return {
				activeIndex: 0,
				airInfo: [],
				ifHasInfo: true,
				// 公司组件参数
				selectComId: this.getCookie('company_id'),
				areaFlag: false,
				// 远程控制
				conFlag: false,
				tts_device_id: 9999,
				deviceData: {}
			}
		},
		methods: {
			toControl(item){				
				this.conFlag = true;
				this.tts_device_id = item.id;
				this.deviceData = item;
				setTimeout(()=>{
					this.$refs.mychild.getFormContent();
				})
				
			},
			changeCom(data){
				this.selectComId = data.selectComId || "";
			
			},
			// 选择公司及区域后调用方法
			toChooseCompanyMethod(){
				this.airInfo = [];
				this.getAirList();
			},
			//获取空调列表开始
			getAirList() {
				let valiCodeParams={
					uid:this.getCookie('uid'),
					company_id: this.selectComId || "",
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Aircondition/AirconditionList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		this.ifDetail = true;
		        		this.airInfo = res.data.data;
		        		
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        		this.ifDetail = false;
		        	}
		  		});
			},
			//获取空调列表结束

		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/device/bigAirCondition.vue